import cookies from 'js-cookie';
import { getRootDomain } from '@/shared/utils/url';

const apiCookieOptions = {
  domain:
    import.meta.env.VITE_ENV !== 'local'
      ? getRootDomain(import.meta.env.VITE_API_BASE_URL, '.')
      : undefined,
};

export const apiCookies = {
  remove: cookies.remove,
  get: cookies.get,
  set: (key: string, value: string) =>
    cookies.set(key, value, apiCookieOptions),
};
